<script setup lang="ts">
import { ref, watch } from 'vue'
import LocationProperties from './LocationProperties.vue'
import MultiSelect from '@/assets/MultiSelect.vue'

interface TagOption {
  id: number
  title: string
}

interface IconOptionItem {
  label: string
  name: string
  svg?: string
}

const props = defineProps<{
  properties: object
  tags: TagOption[]
  selectedTagIds: number[]
  iconOptions: IconOptionItem[]
  selectedIcon: string
  syncsWithDataHub: boolean
  errors: Record<string, string[]>
  mode: 'create' | 'edit'
}>()

const emit = defineEmits<{
  'update:properties': [value: object]
  'update:selectedTagIds': [value: number[]]
  'update:selectedIcon': [value: string]
  'update:syncsWithDataHub': [value: boolean]
}>()

const localProperties = ref<object>(props.properties)
const localTagIds = ref<number[]>([...props.selectedTagIds])
const localIcon = ref<string>(props.selectedIcon ?? '')
const localSyncsWithDataHub = ref<boolean>(props.syncsWithDataHub ?? false)

const onPropertiesChanged = (val: object) => {
  localProperties.value = val
  emit('update:properties', val)
}

watch(localTagIds, (val) => {
  emit('update:selectedTagIds', val)
}, { deep: true })

watch(localIcon, (val) => {
  emit('update:selectedIcon', val)
})

watch(localSyncsWithDataHub, (val) => {
  emit('update:syncsWithDataHub', val)
})
</script>

<template>
  <div>
    <h5 class="text-lg font-bold mb-4">Texte für die App-Schnittstelle</h5>
    <location-properties :values="localProperties" @update:model-value="onPropertiesChanged" />

    <div class="divider"></div>

    <h5 class="text-lg font-bold mb-4">Verknüpfungen für die App-Schnittstelle</h5>
    <label class="form-control mb-4">
      <div class="label">
        <span class="label-text">Tags / Verknüpfungen <span class="text-muted">(mehrere auswählbar)</span></span>
      </div>
      <multi-select v-model="localTagIds" :items="tags" label-property="title" value-property="id" size="sm"></multi-select>
    </label>
    <label class="form-control mb-4">
      <div class="label">
        <span class="label-text">Icon für Orientierungstool</span>
      </div>
      <multi-select v-model="localIcon" :items="iconOptions" label-property="label" value-property="name" size="sm" :multiple="false">
        <template v-slot:option="{ item }">
          <span v-html="item.svg"></span>
        </template>
      </multi-select>
    </label>

    <template v-if="mode === 'edit'">
      <div class="divider"></div>

      <h5 class="text-lg font-bold mb-4">Data Hub NRW</h5>
      <div class="form-control mt-2">
        <label class="label cursor-pointer justify-start">
          <input
            type="checkbox"
            class="toggle mr-2"
            v-model="localSyncsWithDataHub"
          />
          <span class="label-text">Ort im Data Hub NRW ausgeben</span>
        </label>
      </div>
    </template>
  </div>
</template>
